// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3rKfE","title":"FrontImage_title__3meZc"};